import { jwtDecode } from 'jwt-decode'

export function isTokenExpired(token: string) {
  const decodedToken = jwtDecode(token) as { exp: number }
  return decodedToken.exp < Date.now() / 1000
}
